module.exports = "<div id=\"{{ $ctrl.chartId }}\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/Chart/LinearChart/linearChart.html
// module id = 1261
// module chunks = 0